/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface CWTicketConfiguration {
  /** Device (configuration) id */
  id?: string;

  /** Device identifier */
  deviceIdentifier?: string;
  _info?: Record<string, string>;
}

export type CWTicketConfigurationDetails = object;

export interface CWItemType {
  id?: string;
  name?: string;
  _info?: Record<string, string>;
}

export interface CWItemStatus {
  id?: string;
  name?: string;
  _info?: Record<string, string>;
}

export interface CWItemCompany {
  id?: string;
  identifier?: string;
  name?: string;
  _info?: Record<string, string>;
}

export interface CWItemContact {
  id?: string;
  name?: string;
  _info?: Record<string, string>;
}

export interface CWItemSite {
  id?: string;
  name?: string;
  _info?: Record<string, string>;
}

export interface CWItemInstalledBy {
  id?: string;
  identifier?: string;
  name?: string;
  _info?: Record<string, string>;
}

export interface CWItemVendor {
  id?: string;
  identifier?: string;
  name?: string;
  _info?: Record<string, string>;
}

export interface CWItemManufacturer {
  id?: string;
  name?: string;
  _info?: Record<string, string>;
}

export interface CWItemSLA {
  id?: string;
  name?: string;
  _info?: Record<string, string>;
}

export interface FlowFilterAttributeDTO {
  /** FlowFilterAttributeDTO constructor. */
  type?: string;

  /** FlowFilterAttributeDTO constructor. */
  name?: string;

  /** FlowFilterAttributeDTO constructor. */
  displayName?: string;
}

export interface FlowFilterAttributeValuesDTO {
  /** FlowFilterAttributeValuesDTO constructor. */
  value?: string;

  /** FlowFilterAttributeValuesDTO constructor. */
  displayValue?: string;
}

/**
 * @example {"status":404,"message":"Resource not found"}
 */
export interface ResponseResourceNotFound {
  status?: number;
  message?: number;
}

/**
 * @example {"message":"Unauthenticated","status":401}
 */
export interface ResponseUnauthenticated {
  status?: number;
  message?: string;
}

/**
 * @example {"message":"Bad request","status":400}
 */
export interface ResponseBadRequest {
  status?: number;
  message?: string;
}

/**
 * @example {"message":"Duplicate connect wise configuration for the User","status":400}
 */
export interface ResponseDublicateRequest {
  status?: number;
  message?: string;
}

/**
 * @example {"status":403,"message":"Forbidden"}
 */
export interface ResponseForbidden {
  status?: number;
  message?: number;
}

/**
 * @example {"message":"error message","code":500}
 */
export interface ResponseServerError {
  message?: string;
  code?: number;
}

/**
 * @example {"message":"Error message","status":500}
 */
export interface ApplicationError {
  status?: number;
  message?: string;
}

export interface PortalSession {
  id?: string;
  token?: number;
  access_url?: string;
  status?: string;

  /** @format data */
  created_at?: string;

  /** @format data */
  expires_at?: string;
  object?: string;
  customer_id?: string;
  linked_customers?: ChargebeeCustomer[];
}

export interface ChargebeeCustomer {
  object?: string;
  customer_id?: string;
  email?: string;
  has_billing_address?: boolean;
  has_payment_method?: boolean;
  has_active_subscription?: boolean;
}

export interface PaginatorLinks {
  first?: string;
  last?: string;
  prev?: number;
  next?: number;
}

export interface PaginatorMeta {
  current_page?: number;
  from?: number;
  last_page?: number;
  path?: string;
  per_page?: number;
  to?: number;
  total?: number;
}

export interface Attachment {
  /** Class Attachment */
  id?: number;

  /** Class Attachment */
  path?: string;

  /**
   * Class Attachment
   * @format date-time
   */
  created_at?: string;

  /**
   * Class Attachment
   * @format date-time
   */
  updated_at?: string;
}

export interface ChatMessage {
  /** App\Models\Message\ChatMessage */
  id?: number;

  /** App\Models\Message\ChatMessage */
  entity_id?: number;

  /** App\Models\Message\ChatMessage */
  channel_id?: string;

  /** App\Models\Message\ChatMessage */
  conversation_id?: string;

  /** App\Models\Message\ChatMessage */
  message_id?: string;

  /** App\Models\Message\ChatMessage */
  channel_type?: string;

  /** App\Models\Message\ChatMessage */
  hash?: string;

  /** App\Models\Message\ChatMessage */
  entity_type?: 'ticket' | 'opportunity' | 'activity';

  /**
   * App\Models\Message\ChatMessage
   * @format date-time
   */
  created_at?: string;

  /**
   * App\Models\Message\ChatMessage
   * @format date-time
   */
  updated_at?: string;
}

export interface MsTeamsUser {
  /** App\Models\ChatUser\MsTeamsUser */
  id?: number;

  /** App\Models\ChatUser\MsTeamsUser */
  user_id?: number;

  /** App\Models\ChatUser\MsTeamsUser */
  ms_teams_configuration_id?: number;

  /** App\Models\ChatUser\MsTeamsUser */
  ms_teams_teams_id?: number;

  /** App\Models\ChatUser\MsTeamsUser */
  system_id?: string;

  /** App\Models\ChatUser\MsTeamsUser */
  mail?: string;

  /**
   * App\Models\ChatUser\MsTeamsUser
   * @format date-time
   */
  created_at?: string;

  /**
   * App\Models\ChatUser\MsTeamsUser
   * @format date-time
   */
  updated_at?: string;
}

export interface SlackUser {
  /** App\Models\ChatUser\SlackUser */
  id?: number;

  /** App\Models\ChatUser\SlackUser */
  slack_configuration_id?: number;

  /** App\Models\ChatUser\SlackUser */
  user_id?: number;

  /** App\Models\ChatUser\SlackUser */
  system_id?: string;

  /** App\Models\ChatUser\SlackUser */
  mail?: string;

  /** App\Models\ChatUser\SlackUser */
  name?: string;

  /**
   * App\Models\ChatUser\SlackUser
   * @format date-time
   */
  created_at?: string;

  /**
   * App\Models\ChatUser\SlackUser
   * @format date-time
   */
  updated_at?: string;
}

export interface ConnectWiseCallBack {
  /** App\Models\ConnectWiseCallBack */
  id?: number;

  /** App\Models\ConnectWiseCallBack */
  company_id?: number;

  /** App\Models\ConnectWiseCallBack */
  data?: string;

  /** App\Models\ConnectWiseCallBack */
  host?: string;

  /**
   * App\Models\ConnectWiseCallBack
   * @format date-time
   */
  created_at?: string;

  /**
   * App\Models\ConnectWiseCallBack
   * @format date-time
   */
  updated_at?: string;
}

export interface Contact {
  /** App\Models\Contact */
  id?: number;

  /** App\Models\Contact */
  user_id?: number;

  /** App\Models\Contact */
  company_id?: number;

  /** App\Models\Contact */
  role?: string;

  /** App\Models\Contact */
  system_id?: number;

  /** App\Models\Contact */
  is_active?: boolean;

  /**
   * App\Models\Contact
   * @format date-time
   */
  created_at?: string;

  /**
   * App\Models\Contact
   * @format date-time
   */
  updated_at?: string;
}

export interface EntityFieldHandler {
  /** App\Models\EntityFieldHandler */
  id?: number;

  /** App\Models\EntityFieldHandler */
  handler_class?: string;

  /** App\Models\EntityFieldHandler */
  entity_type?: string;

  /** App\Models\EntityFieldHandler */
  is_active?: number;

  /**
   * App\Models\EntityFieldHandler
   * @format date-time
   */
  created_at?: string;

  /**
   * App\Models\EntityFieldHandler
   * @format date-time
   */
  updated_at?: string;
}

export interface Event {
  /** App\Models\Event */
  id?: number;

  /** App\Models\Event */
  user_id?: number;

  /** App\Models\Event */
  action?: string;

  /**
   * App\Models\Event
   * @format date-time
   */
  created_at?: string;

  /**
   * App\Models\Event
   * @format date-time
   */
  updated_at?: string;
}

export interface FlowItemInit {
  /** App\Models\FlowItemInit */
  id?: number;

  /** App\Models\FlowItemInit */
  company_id?: number;

  /** App\Models\FlowItemInit */
  board?: number;

  /** App\Models\FlowItemInit */
  channel?: number;

  /** App\Models\FlowItemInit */
  status?: number;

  /**
   * App\Models\FlowItemInit
   * @format date-time
   */
  created_at?: string;

  /**
   * App\Models\FlowItemInit
   * @format date-time
   */
  updateed_at?: string;
}

export interface FlowStatus {
  /** App\Models\FlowStatus */
  id?: number;

  /** App\Models\FlowStatus */
  flow_channel_id?: number;

  /** App\Models\FlowStatus */
  status_id?: number;

  /** App\Models\FlowStatus */
  parent_id?: string;

  /** App\Models\FlowStatus */
  node_id?: string;

  /** App\Models\FlowStatus */
  is_parent?: number;

  /**
   * App\Models\FlowStatus
   * @format date-time
   */
  created_at?: string;

  /**
   * App\Models\FlowStatus
   * @format date-time
   */
  updated_at?: string;
}

export interface Member {
  /** App\Models\Member */
  id?: number;

  /** App\Models\Member */
  user_id?: number;

  /** App\Models\Member */
  company_id?: number;

  /** App\Models\Member */
  role?: string;

  /** App\Models\Member */
  sysytem_id?: number;

  /**
   * App\Models\Member
   * @format date-time
   */
  created_at?: string;

  /**
   * App\Models\Member
   * @format date-time
   */
  updated_at?: string;
}

export interface Opportunity {
  /** App\Models\Opportunity */
  id?: number;

  /** App\Models\Opportunity */
  user_id?: number;

  /** App\Models\Opportunity */
  system_id?: number;

  /** App\Models\Opportunity */
  channel_system_id?: string;

  /** App\Models\Opportunity */
  skip_callback?: number;

  /**
   * App\Models\Opportunity
   * @format date-time
   */
  created_at?: string;

  /**
   * App\Models\Opportunity
   * @format date-time
   */
  updated_at?: string;
}

export interface OpportunityStatus {
  /** App\Models\OpportunityStatus */
  id?: number;

  /** App\Models\OpportunityStatus */
  company_id?: number;

  /** App\Models\OpportunityStatus */
  system_id?: number;

  /** App\Models\OpportunityStatus */
  name?: string;

  /** App\Models\OpportunityStatus */
  closed?: number;

  /**
   * App\Models\OpportunityStatus
   * @format date-time
   */
  created_at?: string;

  /**
   * App\Models\OpportunityStatus
   * @format date-time
   */
  updated_at?: string;
}

export interface PlanFeature {
  /** App\Models\PlanFeature. */
  id?: number;

  /** App\Models\PlanFeature. */
  plan_id?: number;

  /** App\Models\PlanFeature. */
  slug?: string;

  /** App\Models\PlanFeature. */
  name?: string;

  /** App\Models\PlanFeature. */
  description?: string;

  /** App\Models\PlanFeature. */
  value?: string;

  /** App\Models\PlanFeature. */
  resettable_period?: number;

  /** App\Models\PlanFeature. */
  resettable_interval?: string;

  /** App\Models\PlanFeature. */
  sort_order?: number;

  /**
   * App\Models\PlanFeature.
   * @format date-time
   */
  created_at?: string;

  /**
   * App\Models\PlanFeature.
   * @format date-time
   */
  updated_at?: string;

  /**
   * App\Models\PlanFeature.
   * @format date-time
   */
  deleted_at?: string;
}

export interface PlanFeatureUsage {
  /** App\Models\PlanSubscriptionUsage. */
  id?: number;

  /** App\Models\PlanSubscriptionUsage. */
  subscription_id?: number;

  /** App\Models\PlanSubscriptionUsage. */
  feature_id?: number;

  /** App\Models\PlanSubscriptionUsage. */
  used?: number;

  /**
   * App\Models\PlanSubscriptionUsage.
   * @format date-time
   */
  valid_until?: string;

  /** App\Models\PlanSubscriptionUsage. */
  timezone?: string;

  /**
   * App\Models\PlanSubscriptionUsage.
   * @format date-time
   */
  created_at?: string;

  /**
   * App\Models\PlanSubscriptionUsage.
   * @format date-time
   */
  updated_at?: string;

  /**
   * App\Models\PlanSubscriptionUsage.
   * @format date-time
   */
  deleted_at?: string;
}

export interface PlanWaitingSubscription {
  /** Class PlanWaitingSubscription */
  id?: number;

  /** Class PlanWaitingSubscription */
  plan_id?: number;

  /** Class PlanWaitingSubscription */
  company_id?: number;

  /**
   * Class PlanWaitingSubscription
   * @format date-time
   */
  created_at?: string;

  /**
   * Class PlanWaitingSubscription
   * @format date-time
   */
  updated_at?: string;
}

export interface ActionPlatform {
  /** Transform the resource into an array. */
  id?: number;

  /** Transform the resource into an array. */
  user_id?: number;

  /** Transform the resource into an array. */
  platform_id?: string;

  /** Transform the resource into an array. */
  configuration?: string;

  /** Transform the resource into an array. */
  is_valid?: boolean;

  /** Transform the resource into an array. */
  is_active?: boolean;
}

export interface ActionPlatformConfiguration {
  /** Transform the resource into an array. */
  id?: number;

  /** Transform the resource into an array. */
  user_id?: number;

  /** Transform the resource into an array. */
  platform_id?: string;

  /** Transform the resource into an array. */
  configuration?: string;

  /** Transform the resource into an array. */
  is_valid?: boolean;

  /** Transform the resource into an array. */
  is_active?: boolean;
}

export interface Board {
  /** Transform the resource into an array. */
  id?: number;

  /** Transform the resource into an array. */
  company_id?: number;

  /** Transform the resource into an array. */
  system_id?: number;

  /** Transform the resource into an array. */
  name?: string;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  created_at?: string;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  updated_at?: string;
}

export interface Channel {
  id?: number;
  company_id?: number;
  system_id?: string;
  category?: string;
  category_id?: string;
  name?: string;

  /** @format date-time */
  created_at?: string;

  /** @format date-time */
  updated_at?: string;
}

export interface ChannelCategory {
  category?: string;
  category_id?: string;
}

export interface Company {
  /** Transform the resource into an array. */
  id?: number;

  /** Transform the resource into an array. */
  name?: string;

  /** Transform the resource into an array. */
  code?: string;

  /** Transform the resource into an array. */
  users?: User[];

  /** Transform the resource into an array. */
  active?: boolean;

  /** Transform the resource into an array. */
  active_users?: number;

  /** Transform the resource into an array. */
  app_id?: string;

  /** Transform the resource into an array. */
  is_provider?: boolean;
  provider?: Provider;
  provider_connection?: ProviderConnection;
  settings?: CompanySettings;

  /** Transform the resource into an array. */
  logo?: { id?: number; path?: string };

  /** Transform the resource into an array. */
  selected_configuration?: string;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  last_seen?: string;

  /** Transform the resource into an array. */
  count_users?: number;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  created_at?: string;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  updated_at?: string;
}

export interface CompanySettings {
  /** Transform the resource into an array. */
  id?: number;

  /** Transform the resource into an array. */
  bot_name?: string;
  sale_board?: Board;
  support_board?: Board;

  /** Transform the resource into an array. */
  support_board_id?: number;

  /** Transform the resource into an array. */
  primary_color?: string;

  /** Transform the resource into an array. */
  secondary_color?: string;

  /** Transform the resource into an array. */
  image?: { id?: number; path?: string };

  /** Transform the resource into an array. */
  logo?: { id?: number; path?: string };

  /** Transform the resource into an array. */
  tray_icon?: { id?: number; path?: string };

  /** Transform the resource into an array. */
  warning_icon?: { id?: number; path?: string };

  /** Transform the resource into an array. */
  danger_icon?: { id?: number; path?: string };

  /** Transform the resource into an array. */
  success_icon?: { id?: number; path?: string };

  /** Transform the resource into an array. */
  info_icon?: { id?: number; path?: string };

  /** Transform the resource into an array. */
  bot_icon?: { id?: number; path?: string };

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  created_at?: string;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  updated_at?: string;
}

export interface Device {
  id?: number;
  name?: string;
  type?: object;
  status?: object;
  company?: object;
  contact?: object;
}

export interface Flow {
  /** Transform the resource into an array. */
  id?: number;

  /** Transform the resource into an array. */
  user_id?: number;

  /** Transform the resource into an array. */
  name?: string;

  /** Transform the resource into an array. */
  filter_data?: string;

  /** Transform the resource into an array. */
  is_create_channel?: boolean;

  /** Transform the resource into an array. */
  is_active?: boolean;

  /** Transform the resource into an array. */
  is_reply_broadcast?: boolean;

  /** Transform the resource into an array. */
  entity_type?: string;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  last_run_time?: string;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  updated_at?: string;
}

export interface FlowFilterAttribute {
  /** Transform the resource into an array. */
  id?: number;

  /** Transform the resource into an array. */
  name?: string;

  /** Transform the resource into an array. */
  display_name?: string;

  /** Transform the resource into an array. */
  type?: string;

  /** Transform the resource into an array. */
  entity?: string;

  /** Transform the resource into an array. */
  endpoint?: string;
}

export interface FlowNotification {
  /** Transform the resource into an array. */
  id?: number;

  /** Transform the resource into an array. */
  flow_id?: number;

  /** Transform the resource into an array. */
  code?: string;
}

export interface MsTeamsConfiguration {
  /** Transform the resource into an array. */
  id?: number;

  /** Transform the resource into an array. */
  company_id?: number;

  /** Transform the resource into an array. */
  tenant_id?: string;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  created_at?: string;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  updated_at?: string;
}

export interface MsTeamsTeams {
  /** Transform the resource into an array. */
  id?: number;

  /** Transform the resource into an array. */
  ms_teams_configuration_id?: number;

  /** Transform the resource into an array. */
  team_name?: string;

  /** Transform the resource into an array. */
  service_url?: string;

  /** Transform the resource into an array. */
  group_id?: string;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  created_at?: string;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  updated_at?: string;
}

export interface PaymentSource {
  /** Transform the resource into an array. */
  id?: number;

  /** Transform the resource into an array. */
  resource_version?: string;

  /** Transform the resource into an array. */
  type?: string;

  /** Transform the resource into an array. */
  reference_id?: string;

  /** Transform the resource into an array. */
  status?: string;

  /** Transform the resource into an array. */
  gateway?: boolean;

  /** Transform the resource into an array. */
  gateway_account_id?: string;

  /** Transform the resource into an array. */
  issuing_country?: string;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  created_at?: string;

  /** Transform the resource into an array. */
  card?: {
    first_name?: string;
    last_name?: string;
    last4?: string;
    brand?: string;
    expiry_month?: string;
    expiry_year?: string;
  };

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  updated_at?: string;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  deleted?: string;
}

export interface Plan {
  /** Transform the resource into an array. */
  id?: number;

  /** Transform the resource into an array. */
  code?: string;

  /** Transform the resource into an array. */
  plan_quantity?: number;

  /** Transform the resource into an array. */
  currency?: string;

  /** Transform the resource into an array. */
  payment_source_id?: number;

  /** Transform the resource into an array. */
  name?: string;

  /** Transform the resource into an array. */
  price?: number;

  /** Transform the resource into an array. */
  description?: string;

  /** Transform the resource into an array. */
  status?: string;

  /** Transform the resource into an array. */
  subscribed?: boolean;
  subscription?: object;

  /** Transform the resource into an array. */
  free?: boolean;

  /** Transform the resource into an array. */
  is_waiting_subscription?: boolean;

  /** Transform the resource into an array. */
  order?: number;
}

export interface Priority {
  /** Transform the resource into an array. */
  id?: number;

  /** Transform the resource into an array. */
  company_id?: number;

  /** Transform the resource into an array. */
  name?: string;

  /** Transform the resource into an array. */
  color?: string;

  /** Transform the resource into an array. */
  sort_order?: number;
}

export interface ProviderPlan {
  /** Transform the resource into an array. */
  id?: number;
  company?: Company;

  /** Transform the resource into an array. */
  type?: string;
}

export interface ProviderConnection {
  /** Transform the resource into an array. */
  id?: number;

  /** Transform the resource into an array. */
  msp_company_id?: number;

  /** Transform the resource into an array. */
  contact_company_id?: number;

  /** Transform the resource into an array. */
  message?: string;

  /** Transform the resource into an array. */
  status?: string;
  msp_company?: Company;
  plan?: ProviderPlan;
  contact_company?: Company;
}

export interface Provider {
  /** Transform the resource into an array. */
  id?: number;

  /** Transform the resource into an array. */
  provider_id?: number;

  /** Transform the resource into an array. */
  name?: string;
}

export interface SlackConfiguration {
  /** Transform the resource into an array. */
  id?: number;

  /** Transform the resource into an array. */
  company_id?: number;

  /** Transform the resource into an array. */
  team_name?: string;

  /** Transform the resource into an array. */
  team_id?: string;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  created_at?: string;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  updated_at?: string;
}

export interface Status {
  /** Transform the resource into an array. */
  id?: number;

  /** Transform the resource into an array. */
  company_id?: number;

  /** Transform the resource into an array. */
  system_id?: number;

  /** Transform the resource into an array. */
  board_id?: number;

  /** Transform the resource into an array. */
  name?: string;

  /** Transform the resource into an array. */
  closed_status?: number;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  created_at?: string;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  updated_at?: string;
}

export interface Subscription {
  /** Transform the resource into an array. */
  id?: number;

  /** Transform the resource into an array. */
  subscription_id?: string;

  /** Transform the resource into an array. */
  plan_id?: number;

  /** Transform the resource into an array. */
  payment_source_id?: string;

  /** Transform the resource into an array. */
  status?: string;

  /** Transform the resource into an array. */
  company_id?: number;

  /** Transform the resource into an array. */
  quantity?: number;

  /** Transform the resource into an array. */
  last_four?: number;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  ends_at?: string;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  trial_ends_at?: string;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  next_billing_at?: string;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  created_at?: string;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  updated_at?: string;
}

export interface Ticket {
  /** Transform the resource into an array. */
  id?: number;

  /** Transform the resource into an array. */
  user_id?: number;

  /** Transform the resource into an array. */
  company_name?: string;

  /** Transform the resource into an array. */
  board_id?: number;

  /** Transform the resource into an array. */
  system_id?: number;

  /** Transform the resource into an array. */
  channels?: Channel[];

  /** Transform the resource into an array. */
  twilio_channel_name?: string;

  /** Transform the resource into an array. */
  summary?: string;

  /** Transform the resource into an array. */
  assigne?: string;

  /** Transform the resource into an array. */
  status?: string;

  /** Transform the resource into an array. */
  url?: string;

  /** Transform the resource into an array. */
  skip_callback?: boolean;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  created_at?: string;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  updated_at?: string;
}

export interface TicketNote {
  id?: number;
  avatar?: string;
  text?: object;

  /** @format date-time */
  date?: string;
  member?: string;
  is_internal?: boolean;
}

export interface User {
  /** Transform the resource into an array. */
  id?: number;

  /** Transform the resource into an array. */
  email?: string;

  /** Transform the resource into an array. */
  role?: 'BASIC_USER' | 'ADMIN_USER';

  /** Transform the resource into an array. */
  is_active?: number;

  /** Transform the resource into an array. */
  fullname?: string;

  /** Transform the resource into an array. */
  test_user?: number;

  /** Transform the resource into an array. */
  sub?: string;

  /** Transform the resource into an array. */
  companies?: Company[];

  /** Transform the resource into an array. */
  chargebee_id?: string;

  /** Transform the resource into an array. */
  phone?: string;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  last_seen?: string;

  /** Transform the resource into an array. */
  entity_notification?: number;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  created_at?: string;

  /**
   * Transform the resource into an array.
   * @format date-time
   */
  updated_at?: string;
}

export interface Workspace {
  /** Transform the resource into an array. */
  id?: number;

  /** Transform the resource into an array. */
  name?: string;

  /** Transform the resource into an array. */
  app_id?: string;

  /** Transform the resource into an array. */
  is_client?: boolean;
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, ResponseType } from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded'
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || 'https://stage-apiui.chatgenie.io/api'
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  private mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig
  ): AxiosRequestConfig {
    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.instance.defaults.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {})
      }
    };
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = (format && this.format) || void 0;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      requestParams.headers.common = { Accept: '*/*' };
      requestParams.headers.post = {};
      requestParams.headers.put = {};

      const formData = new FormData();
      for (const key in body) {
        formData.append(key, body[key as keyof typeof body]);
      }
      body = formData;
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
        ...(requestParams.headers || {})
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path
    });
  };
}

/**
 * @title Chat Genie
 * @version 1.0.0
 * @baseUrl https://stage-apiui.chatgenie.io/api
 *
 * Chat Genie Api
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  actionPlatform = {
    /**
     * @description Returns configurations
     *
     * @tags ActionPlatform Configurations
     * @name GetActionPlatformConfiguration
     * @summary Returns configurations
     * @request GET:/action-platform/configurations
     * @secure
     */
    getActionPlatformConfiguration: (params: RequestParams = {}) =>
      this.request<{ data?: ActionPlatformConfiguration[] }, any>({
        path: `/action-platform/configurations`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Add new configuration for user.
     *
     * @tags ActionPlatform Configurations
     * @name Store
     * @summary Add new configuration for user
     * @request POST:/action-platform/configurations
     * @secure
     */
    store: (
      data: { platform_id?: number; configuration?: string; is_active?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<{ data?: ActionPlatformConfiguration[] }, any>({
        path: `/action-platform/configurations`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Update configuration by id
     *
     * @tags ActionPlatform Configurations
     * @name Show
     * @summary Return configuration by id
     * @request GET:/action-platform/configurations/{id}
     * @secure
     */
    show: (id: number, params: RequestParams = {}) =>
      this.request<{ data?: ActionPlatformConfiguration[] }, any>({
        path: `/action-platform/configurations/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Update configuration by id
     *
     * @tags ActionPlatform Configurations
     * @name Update
     * @summary Update configuration by id
     * @request POST:/action-platform/configurations/{id}
     * @secure
     */
    update: (
      id: number,
      data: { configuration?: string; is_active?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<{ data?: ActionPlatformConfiguration[] }, any>({
        path: `/action-platform/configurations/${id}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Destroy a Actoion platform configuration.
     *
     * @tags ActionPlatform Configurations
     * @name Destroy
     * @summary Destroy a Actoion platform configuration
     * @request DELETE:/action-platform/configurations/{id}
     * @secure
     */
    destroy: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/action-platform/configurations/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description list of action platforms.
     *
     * @tags ActionPlatform ActionPlatforms
     * @name Index
     * @summary list of action platforms
     * @request GET:/action-platform/platforms
     * @secure
     */
    index: (params: RequestParams = {}) =>
      this.request<{ data?: ActionPlatform[] }, any>({
        path: `/action-platform/platforms`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description MsTeams auth (integration)
     *
     * @tags ActionPlatform MsTeam
     * @name Auth
     * @summary MsTeams auth (integration)
     * @request POST:/action-platform/ms-team/auth
     * @secure
     */
    auth: (
      query: { code: string },
      data: { verificationHash?: string },
      params: RequestParams = {}
    ) =>
      this.request<{ data?: MsTeamsConfiguration }, any>({
        path: `/action-platform/ms-team/auth`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description MsTeams sign in
     *
     * @tags ActionPlatform MsTeam
     * @name Auth2
     * @summary MsTeams sign in
     * @request POST:/action-platform/ms-team/sign-in
     * @originalName auth
     * @duplicate
     * @secure
     */
    auth2: (
      query: { redirectUri: string },
      data: { authUrl?: string },
      params: RequestParams = {}
    ) =>
      this.request<{ data?: MsTeamsConfiguration }, any>({
        path: `/action-platform/ms-team/sign-in`,
        method: 'POST',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Return msteam configuration
     *
     * @tags ActionPlatform MsTeam
     * @name GetConfiguration
     * @summary Gets msteams configiration
     * @request GET:/action-platform/ms-team/configuration
     * @secure
     */
    getConfiguration: (params: RequestParams = {}) =>
      this.request<{ data?: MsTeamsConfiguration }, any>({
        path: `/action-platform/ms-team/configuration`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description return array of teams by configurationID
     *
     * @tags ActionPlatform MsTeam
     * @name GetTeams
     * @summary Gets teams for configiration
     * @request GET:/action-platform/ms-team/configuration/ms-teams
     * @secure
     */
    getTeams: (params: RequestParams = {}) =>
      this.request<{ data?: any[] }, any>({
        path: `/action-platform/ms-team/configuration/ms-teams`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Slack auth (integration)
     *
     * @tags ActionPlatform Slack
     * @name SlackAuth
     * @summary Slack auth (integration)
     * @request POST:/action-platform/slack/auth
     * @secure
     */
    slackAuth: (data: { code?: string; redirectUri?: string }, params: RequestParams = {}) =>
      this.request<{ data?: object }, any>({
        path: `/action-platform/slack/auth`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Twilio auth
     *
     * @tags ActionPlatform Twilio
     * @name TwilioAuth
     * @summary Twilio auth
     * @request POST:/action-platform/twilio/token
     * @secure
     */
    twilioAuth: (data: { push_channel?: string; identity: string }, params: RequestParams = {}) =>
      this.request<{ data?: { token?: string; identity?: string } }, any>({
        path: `/action-platform/twilio/token`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Twilio create a ticket
     *
     * @tags ActionPlatform Twilio
     * @name TwilioCreateTicket
     * @summary Twilio create a ticket
     * @request POST:/action-platform/twilio/ticket
     * @secure
     */
    twilioCreateTicket: (
      data: {
        summary: string;
        initial_description?: string;
        contact_system_id?: number;
        board?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          data?: {
            channel_name?: string;
            company_id?: number;
            contact_id?: number;
            ticket_id?: number;
          };
        },
        any
      >({
        path: `/action-platform/twilio/ticket`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Twilio create a channel
     *
     * @tags ActionPlatform Twilio
     * @name TwilioCreateChannel
     * @summary Twilio create a channel
     * @request POST:/action-platform/twilio/channel
     * @secure
     */
    twilioCreateChannel: (data: { ticketId: number }, params: RequestParams = {}) =>
      this.request<{ data?: { channel_name?: string } }, any>({
        path: `/action-platform/twilio/channel`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * No description
     *
     * @tags ActionPlatform ConnectWise
     * @name Auth3
     * @summary Connect wise auth (integration)
     * @request POST:/action-platform/connect-wise/auth
     * @originalName auth
     * @duplicate
     * @secure
     */
    auth3: (
      data: { host?: string; company_name?: string; private_key?: string; public_key?: string },
      params: RequestParams = {}
    ) =>
      this.request<{ data?: string }, any>({
        path: `/action-platform/connect-wise/auth`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      })
  };
  oauth = {
    /**
     * @description Sened code.
     *
     * @tags Oauth Passwordless
     * @name PasswordlessStart
     * @summary Send code.
     * @request POST:/oauth/passwordless/start
     * @secure
     */
    passwordlessStart: (
      data: {
        email?: string;
        fullname?: string;
        company_name?: string;
        phone_number?: string;
        connection: string;
        send?: string;
        redirect_uri?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<{ data?: boolean }, any>({
        path: `/oauth/passwordless/start`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params
      }),

    /**
     * @description Returns token.
     *
     * @tags Oauth Passwordless
     * @name PasswordlessOauthToken
     * @summary Returns token.
     * @request POST:/oauth/passwordless/token
     * @secure
     */
    passwordlessOauthToken: (
      data: {
        audience: string;
        scope?: string;
        otp: number;
        phone?: string;
        email: string;
        realm: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<
        { data?: { access_token?: string; expires_in?: number; token_type?: string } },
        any
      >({
        path: `/oauth/passwordless/token`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params
      })
  };
  billing = {
    /**
     * @description Returns portal session.
     *
     * @tags Billing Checkout
     * @name PortalCreateSession
     * @summary returns Portal session.
     * @request GET:/billing/checkout/create
     * @secure
     */
    portalCreateSession: (query: { plan_id: string }, params: RequestParams = {}) =>
      this.request<{ data?: PortalSession[] }, any>({
        path: `/billing/checkout/create`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Return Payment Source.
     *
     * @tags Billing PaymentSources
     * @name PaymentSources
     * @summary return Payment Sources.
     * @request GET:/billing/paymentsources
     * @secure
     */
    paymentSources: (params: RequestParams = {}) =>
      this.request<{ data?: PaymentSource[] }, any>({
        path: `/billing/paymentsources`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Return plans.
     *
     * @tags Billing Plans
     * @name PlanList
     * @summary return Plans.
     * @request GET:/billing/plans
     * @secure
     */
    planList: (query?: { per_page?: number }, params: RequestParams = {}) =>
      this.request<{ data?: Plan[]; links?: PaginatorLinks; meta?: PaginatorMeta }, any>({
        path: `/billing/plans`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Set plan in progress for subscription.
     *
     * @tags Billing Plans
     * @name PlanInProgress
     * @summary Set plan in progress for subscription.
     * @request POST:/billing/plans/{plan_id}/set-in-progress-status
     * @secure
     */
    planInProgress: (planId: number, params: RequestParams = {}) =>
      this.request<{ data?: string }, any>({
        path: `/billing/plans/${planId}/set-in-progress-status`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Return portal session.
     *
     * @tags Billing Portal
     * @name PortalCreateSession2
     * @summary return Portal session.
     * @request GET:/billing/portal/create-session
     * @originalName portalCreateSession
     * @duplicate
     * @secure
     */
    portalCreateSession2: (params: RequestParams = {}) =>
      this.request<{ data?: PortalSession[] }, any>({
        path: `/billing/portal/create-session`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Return portal session.
     *
     * @tags Billing Portal
     * @name PortalLogout
     * @summary return Portal session.
     * @request POST:/billing/portal/logout
     * @secure
     */
    portalLogout: (query: { sessionId: string }, params: RequestParams = {}) =>
      this.request<{ data?: PortalSession[] }, any>({
        path: `/billing/portal/logout`,
        method: 'POST',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description List of subsciptions
     *
     * @tags Billing Subscriptions
     * @name List
     * @summary List of subsciptions
     * @request GET:/billing/subscriptions
     * @secure
     */
    list: (params: RequestParams = {}) =>
      this.request<{ data?: Subscription[] }, any>({
        path: `/billing/subscriptions`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Create subsciption
     *
     * @tags Billing Subscriptions
     * @name Create
     * @summary Create subsciption
     * @request POST:/billing/subscriptions
     * @secure
     */
    create: (query: { planId: number; active: boolean }, params: RequestParams = {}) =>
      this.request<{ data?: Subscription }, any>({
        path: `/billing/subscriptions`,
        method: 'POST',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Update subsciption
     *
     * @tags Billing Subscriptions
     * @name Update
     * @summary Update subsciption
     * @request POST:/billing/subscriptions/{id}
     * @secure
     */
    update: (
      id: number,
      query: { planId: number; quantity?: number },
      params: RequestParams = {}
    ) =>
      this.request<{ data?: Subscription }, any>({
        path: `/billing/subscriptions/${id}`,
        method: 'POST',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Cancel subsciptions
     *
     * @tags Billing Subscriptions
     * @name Cancel
     * @summary Cancel subsciption
     * @request POST:/billing/subscriptions/{id}/cancel
     * @secure
     */
    cancel: (id: number, params: RequestParams = {}) =>
      this.request<{ data?: Subscription }, any>({
        path: `/billing/subscriptions/${id}/cancel`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params
      })
  };
  boards = {
    /**
     * @description Return list of boards
     *
     * @tags Boards
     * @name Board
     * @summary Return boards for login user
     * @request GET:/boards
     * @secure
     */
    board: (query?: { per_page?: number }, params: RequestParams = {}) =>
      this.request<{ data?: any[]; links?: PaginatorLinks; meta?: PaginatorMeta }, any>({
        path: `/boards`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      })
  };
  canny = {
    /**
     * @description Return the Canny token
     *
     * @tags Canny
     * @name Canny
     * @summary return the Canny token
     * @request GET:/canny/token
     * @secure
     */
    canny: (params: RequestParams = {}) =>
      this.request<{ data?: { token?: string } }, any>({
        path: `/canny/token`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      })
  };
  channel = {
    /**
     * @description Return categories of channels
     *
     * @tags Channel ChannelCategories
     * @name ChannelCategory
     * @summary Return list of channel categories models
     * @request GET:/channel/channel-categories
     * @secure
     */
    channelCategory: (query?: { limit?: number }, params: RequestParams = {}) =>
      this.request<{ data?: object }, any>({
        path: `/channel/channel-categories`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Return channels
     *
     * @tags Channel Channels
     * @name Channel
     * @summary Return list of channel models
     * @request GET:/channel/channels
     * @secure
     */
    channel: (query?: { per_page?: number }, params: RequestParams = {}) =>
      this.request<{ data?: any[]; links?: PaginatorLinks; meta?: PaginatorMeta }, any>({
        path: `/channel/channels`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Creating a chat channel using integration
     *
     * @tags Channel Channels
     * @name StoreChannel
     * @summary Creating a chat channel
     * @request POST:/channel/channels
     * @secure
     */
    storeChannel: (data: { name?: string; category_id?: number }, params: RequestParams = {}) =>
      this.request<{ data?: object }, any>({
        path: `/channel/channels`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      })
  };
  companies = {
    /**
     * @description Return company models.
     *
     * @tags Companies
     * @name Companies
     * @summary return Company models.
     * @request GET:/companies
     * @secure
     */
    companies: (
      query?: { per_page?: number; client_companies?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<{ data?: any[]; links?: PaginatorLinks; meta?: PaginatorMeta }, any>({
        path: `/companies`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Return a newly company
     *
     * @tags Companies
     * @name StoreANewlyCreatedCompany
     * @summary Store a newly created company.
     * @request POST:/companies
     * @secure
     */
    storeANewlyCreatedCompany: (data: { name: string; logo?: File }, params: RequestParams = {}) =>
      this.request<{ data?: Company }, any>({
        path: `/companies`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params
      }),

    /**
     * @description Retrieves the company with the given ID.
     *
     * @tags Companies
     * @name GetCompany
     * @summary Retrieves the company with the given ID.
     * @request GET:/companies/{id}
     * @secure
     */
    getCompany: (id: string, params: RequestParams = {}) =>
      this.request<{ data?: Company }, any>({
        path: `/companies/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Updates the specified company by setting the values of the parameters passed.
     *
     * @tags Companies
     * @name UpdateCompany
     * @summary Updates the specified company by setting the values of the parameters passed.
     * @request POST:/companies/{id}
     * @secure
     */
    updateCompany: (id: string, data: { name?: string }, params: RequestParams = {}) =>
      this.request<{ data?: Company }, any>({
        path: `/companies/${id}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params
      }),

    /**
     * @description Deletes the company with the given ID.
     *
     * @tags Companies
     * @name DeleteCompany
     * @summary Deletes the company with the given ID.
     * @request DELETE:/companies/{id}
     * @secure
     */
    deleteCompany: (id: string, params: RequestParams = {}) =>
      this.request<{ data?: boolean }, any>({
        path: `/companies/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Imports contacts.
     *
     * @tags Company Contacts
     * @name ImportCompanyContacts
     * @summary Imports contacts.
     * @request POST:/companies/{id}/import-contacts
     * @secure
     */
    importCompanyContacts: (id: number, params: RequestParams = {}) =>
      this.request<{ data?: boolean }, any>({
        path: `/companies/${id}/import-contacts`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Retrieves the users of company with the given ID.
     *
     * @tags Company Users
     * @name CompanyUsers
     * @summary Retrieves the users of company with the given ID.
     * @request GET:/companies/{id}/users
     * @secure
     */
    companyUsers: (id: string, params: RequestParams = {}) =>
      this.request<{ data?: any[]; links?: PaginatorLinks; meta?: PaginatorMeta }, any>({
        path: `/companies/${id}/users`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Return list of users tickets
     *
     * @tags Company User Tickets
     * @name CompanyUserTickets
     * @summary Return list of users tickets
     * @request GET:/companies/{companyId}/users/{userId}/tickets
     * @secure
     */
    companyUserTickets: (
      companyId: number,
      userId: number,
      query?: { per_page?: number },
      params: RequestParams = {}
    ) =>
      this.request<{ data?: Ticket[]; links?: PaginatorLinks; meta?: PaginatorMeta }, any>({
        path: `/companies/${companyId}/users/${userId}/tickets`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description retrieves company's devices with the given company id.
     *
     * @tags Company Devices
     * @name GetCompanyDevices
     * @summary Retrieves company's devices with the given company id.
     * @request GET:/companies/{id}/devices
     * @secure
     */
    getCompanyDevices: (id: string, params: RequestParams = {}) =>
      this.request<{ data?: Device }, any>({
        path: `/companies/${id}/devices`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      })
  };
  companyProviders = {
    /**
     * @description Return provider models.
     *
     * @tags CompanyProviders
     * @name CompanyProviders
     * @summary return Providers.
     * @request GET:/company-providers
     * @secure
     */
    companyProviders: (query?: { per_page?: number }, params: RequestParams = {}) =>
      this.request<{ data?: any[]; links?: PaginatorLinks; meta?: PaginatorMeta }, any>({
        path: `/company-providers`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Return connections.
     *
     * @tags CompanyProviders
     * @name ProviderPlans
     * @summary return Company models.
     * @request GET:/company-providers/{providerId}/plans
     * @secure
     */
    providerPlans: (
      providerId: number,
      query?: { per_page?: number },
      params: RequestParams = {}
    ) =>
      this.request<{ data?: any[]; links?: PaginatorLinks; meta?: PaginatorMeta }, any>({
        path: `/company-providers/${providerId}/plans`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Return a plan
     *
     * @tags CompanyProviders
     * @name UpdateAPlan
     * @summary Update a plan.
     * @request POST:/company-providers/{providerId}/plans/{id}
     * @secure
     */
    updateAPlan: (
      providerId: number,
      data: {
        provider_id: number;
        msp_company_id?: number;
        contact_company_id?: number;
        status?: string;
        message?: string;
      },
      id?: number,
      params: RequestParams = {}
    ) =>
      this.request<{ data?: ProviderPlan }, any>({
        path: `/company-providers/${providerId}/plans/${id}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params
      })
  };
  devices = {
    /**
     * @description Returns a device details
     *
     * @tags Devices
     * @name GetTicketDeviceDetails
     * @summary Get a configuration detailed info
     * @request GET:/devices/{id}
     * @secure
     */
    getTicketDeviceDetails: (id: number, params: RequestParams = {}) =>
      this.request<{ data?: Device }, any>({
        path: `/devices/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      })
  };
  users = {
    /**
     * @description retrieves company's devices with the given company id.
     *
     * @tags User Devices
     * @name GetUserDevices
     * @summary Retrieves user's devices with the given user id.
     * @request GET:/users/{id}/devices
     * @secure
     */
    getUserDevices: (id: string, params: RequestParams = {}) =>
      this.request<{ data?: Device }, any>({
        path: `/users/${id}/devices`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Return list of users tickets
     *
     * @tags User Tickets
     * @name UserTickets
     * @summary Return list of users tickets
     * @request GET:/users/{id}/tickets
     * @secure
     */
    userTickets: (id: number, query?: { per_page?: number }, params: RequestParams = {}) =>
      this.request<{ data?: Ticket[]; links?: PaginatorLinks; meta?: PaginatorMeta }, any>({
        path: `/users/${id}/tickets`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Return users
     *
     * @tags Users
     * @name User
     * @summary Return list of user models
     * @request GET:/users
     * @secure
     */
    user: (query?: { contact?: boolean; per_page?: number }, params: RequestParams = {}) =>
      this.request<{ data?: any[]; links?: PaginatorLinks; meta?: PaginatorMeta }, any>({
        path: `/users`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Return a newly user
     *
     * @tags Users
     * @name StoreANewlyCreatedUser
     * @summary Store a newly created user.
     * @request POST:/users
     * @secure
     */
    storeANewlyCreatedUser: (
      data: { fullname: string; email: string; is_active?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<{ data?: User }, any>({
        path: `/users`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Retrieves the user with the given ID.
     *
     * @tags Users
     * @name GetUser
     * @summary Retrieves the user with the given ID.
     * @request GET:/users/{id}
     * @secure
     */
    getUser: (id: string, params: RequestParams = {}) =>
      this.request<{ data?: User }, any>({
        path: `/users/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Update a user
     *
     * @tags Users
     * @name UserUpdate
     * @summary Update a user
     * @request POST:/users/{id}
     * @secure
     */
    userUpdate: (
      id: number,
      data: { is_active?: boolean; entity_notification?: number },
      params: RequestParams = {}
    ) =>
      this.request<{ data?: object }, any>({
        path: `/users/${id}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Returns a user by en email
     *
     * @tags Users
     * @name ReturnsAUserByEnEmail
     * @summary Returns a user by en email.
     * @request GET:/users/{email}/by-email
     */
    returnsAUserByEnEmail: (
      email: string,
      query?: { app_id?: string },
      params: RequestParams = {}
    ) =>
      this.request<{ data?: { email?: string; last_4_phone?: number } }, any>({
        path: `/users/${email}/by-email`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params
      }),

    /**
     * @description Send an invitation to application.
     *
     * @tags Users
     * @name SendInviteLink
     * @summary Send an invitation to application.
     * @request GET:/users/{id}/send-invite-link
     * @secure
     */
    sendInviteLink: (
      id: number,
      query: { invited_company_id: number },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/users/${id}/send-invite-link`,
        method: 'GET',
        query: query,
        secure: true,
        ...params
      })
  };
  tickets = {
    /**
     * @description Return devices
     *
     * @tags Ticket Devices
     * @name TicketDevices
     * @summary Return list of devices
     * @request GET:/tickets/{id}/devices
     * @secure
     */
    ticketDevices: (id: number, params: RequestParams = {}) =>
      this.request<{ data?: any[]; links?: PaginatorLinks; meta?: PaginatorMeta }, any>({
        path: `/tickets/${id}/devices`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Returns the attached device
     *
     * @tags Ticket Devices
     * @name AttachDevice
     * @summary Attach a device to a ConnectWise ticket
     * @request POST:/tickets/{id}/devices
     * @secure
     */
    attachDevice: (
      id: number,
      data: { id: string; device_identifier?: string; info?: Record<string, string> },
      params: RequestParams = {}
    ) =>
      this.request<{ data?: object }, any>({
        path: `/tickets/${id}/devices`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Return list of companies tickets.
     *
     * @tags Tickets
     * @name Tickets
     * @summary Return list of companies tickets
     * @request GET:/tickets
     * @secure
     */
    tickets: (
      query?: {
        per_page?: number;
        company_type?: string;
        service_source?: string;
        connectedCompanyId?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<{ data?: Ticket[]; links?: PaginatorLinks; meta?: PaginatorMeta }, any>({
        path: `/tickets`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Retrieves the ticket with the given ID.
     *
     * @tags Tickets
     * @name GetTicket
     * @summary Retrieves the ticket with the given ID.
     * @request GET:/tickets/{id}
     * @secure
     */
    getTicket: (id: string, params: RequestParams = {}) =>
      this.request<{ data?: Ticket }, any>({
        path: `/tickets/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Return list of the notes.
     *
     * @tags Ticket Notes
     * @name NotesForTheTicket
     * @summary Return list of the notes
     * @request GET:/tickets/{id}/notes
     * @secure
     */
    notesForTheTicket: (id: number, params: RequestParams = {}) =>
      this.request<{ data?: any[]; links?: PaginatorLinks; meta?: PaginatorMeta }, any>({
        path: `/tickets/${id}/notes`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Saving a new note
     *
     * @tags Ticket Notes
     * @name SavingANewNote
     * @summary Saving a new note
     * @request POST:/tickets/{id}/notes
     * @secure
     */
    savingANewNote: (
      id: number,
      data: { text?: string; is_external?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<{ data?: object }, any>({
        path: `/tickets/${id}/notes`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      })
  };
  flow = {
    /**
     * @description Return flows.
     *
     * @tags Flow Flows
     * @name Flows
     * @summary return Flows.
     * @request GET:/flow/flows
     * @secure
     */
    flows: (query?: { per_page?: number }, params: RequestParams = {}) =>
      this.request<{ data?: Flow[]; links?: PaginatorLinks; meta?: PaginatorMeta }, any>({
        path: `/flow/flows`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Return newly flow
     *
     * @tags Flow Flows
     * @name StoreANewlyCreatedFlow
     * @summary Store a newly created flow.
     * @request POST:/flow/flows
     * @secure
     */
    storeANewlyCreatedFlow: (
      data: {
        name?: string;
        filter_data?: string;
        is_active?: boolean;
        is_create_channel?: boolean;
        is_reply_broadcast?: boolean;
        channel_id?: number;
        entity_type?: string;
        notifications?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<{ data?: object }, any>({
        path: `/flow/flows`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Return flows by ID.
     *
     * @tags Flow Flows
     * @name Show
     * @summary return Flow by ID
     * @request GET:/flow/flows/{flow_id}
     * @secure
     */
    show: (flowId: number, params: RequestParams = {}) =>
      this.request<{ data?: object }, any>({
        path: `/flow/flows/${flowId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Return updated flow
     *
     * @tags Flow Flows
     * @name UpdateExistingFlow
     * @summary Update existing flow.
     * @request POST:/flow/flows/{id}
     * @secure
     */
    updateExistingFlow: (
      id: number,
      data: {
        name?: string;
        filter_data?: string;
        is_active?: boolean;
        is_create_channel?: boolean;
        is_reply_broadcast?: boolean;
        channel_id?: number;
        entity_type?: string;
        notification?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<{ data?: object }, any>({
        path: `/flow/flows/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params
      }),

    /**
     * @description Destroy a flow.
     *
     * @tags Flow Flows
     * @name Destroy
     * @summary Destroy a flow
     * @request DELETE:/flow/flows/{id}
     * @secure
     */
    destroy: (id: number, params: RequestParams = {}) =>
      this.request<{ status?: number; message?: string }, any>({
        path: `/flow/flows/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Start UpdateChannelJob, UpdateBoardJob, UpdateSlackUserJob, UpdateMsTeamsUserJob.
     *
     * @tags Flow Items
     * @name FlowItemsInit
     * @summary Update storage
     * @request GET:/flow/items-init
     * @secure
     */
    flowItemsInit: (params: RequestParams = {}) =>
      this.request<{ data?: string }, any>({
        path: `/flow/items-init`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Return OK if flow is ready.
     *
     * @tags Flow Items
     * @name FlowItemsReady
     * @summary Return OK if flow is ready
     * @request GET:/flow/items-ready
     * @secure
     */
    flowItemsReady: (params: RequestParams = {}) =>
      this.request<{ data?: { status?: string } }, any>({
        path: `/flow/items-ready`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Returns a list of attributes.
     *
     * @tags Flow FilterAttributes
     * @name Index
     * @summary Return list of attributes.
     * @request GET:/flow/filter-attributes
     * @secure
     */
    index: (params: RequestParams = {}) =>
      this.request<{ data?: FlowFilterAttributeDTO[] }, any>({
        path: `/flow/filter-attributes`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Return a list of values for a specific attribute. For autocomplete.
     *
     * @tags Flow FilterAttributes
     * @name Show2
     * @summary Return FilterAttribute by ID
     * @request GET:/flow/filter-attributes/{id}/value
     * @originalName show
     * @duplicate
     * @secure
     */
    show2: (id: number, query?: { like?: string }, params: RequestParams = {}) =>
      this.request<{ data?: { value?: string; displayValue?: string } }, any>({
        path: `/flow/filter-attributes/${id}/value`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      })
  };
  companyProvider = {
    /**
     * @description Return connections.
     *
     * @tags CompanyProviders
     * @name ProviderConnections
     * @summary return Connection models.
     * @request GET:/company-provider/connections
     * @secure
     */
    providerConnections: (query?: { per_page?: number }, params: RequestParams = {}) =>
      this.request<{ data?: any[]; links?: PaginatorLinks; meta?: PaginatorMeta }, any>({
        path: `/company-provider/connections`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Return a newly connection
     *
     * @tags CompanyProviders
     * @name StoreANewlyCreatedConnection
     * @summary Store a newly created connection.
     * @request POST:/company-provider/connections
     * @secure
     */
    storeANewlyCreatedConnection: (
      data: {
        provider_id: number;
        plan_id?: number;
        msp_company_id?: number;
        contact_company_id?: number;
        status?: string;
        message?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<{ data?: ProviderConnection }, any>({
        path: `/company-provider/connections`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params
      }),

    /**
     * @description Return a connection
     *
     * @tags CompanyProviders
     * @name ReturnAConnection
     * @summary Return a connection.
     * @request GET:/company-provider/connections/{id}
     * @secure
     */
    returnAConnection: (id: number, params: RequestParams = {}) =>
      this.request<{ data?: ProviderConnection }, any>({
        path: `/company-provider/connections/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Return a newly connection
     *
     * @tags CompanyProviders
     * @name UpdateANewlyCreatedConnection
     * @summary Update a newly created connection.
     * @request POST:/company-provider/connections/{id}
     * @secure
     */
    updateANewlyCreatedConnection: (
      data: {
        provider_id: number;
        provider_plan_id?: number;
        msp_company_id?: number;
        contact_company_id?: number;
        status?: string;
        message?: string;
      },
      id?: number,
      params: RequestParams = {}
    ) =>
      this.request<{ data?: ProviderConnection }, any>({
        path: `/company-provider/connections/${id}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params
      }),

    /**
     * @description Deletes the connection with the given ID.
     *
     * @tags CompanyProviders
     * @name DeleteProviderConnection
     * @summary Deletes the connection with the given ID.
     * @request DELETE:/company-provider/connection/{id}
     * @secure
     */
    deleteProviderConnection: (id: string, params: RequestParams = {}) =>
      this.request<{ data?: boolean }, any>({
        path: `/company-provider/connection/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Return a newly plan
     *
     * @tags CompanyProviders
     * @name StoreANewlyCreatedPlan
     * @summary Store a newly created plan.
     * @request POST:/company-provider/{providerId}/plans
     * @secure
     */
    storeANewlyCreatedPlan: (
      providerId: number,
      data: {
        provider_id: number;
        msp_company_id?: number;
        contact_company_id?: number;
        status?: string;
        message?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<{ data?: ProviderPlan }, any>({
        path: `/company-provider/${providerId}/plans`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params
      }),

    /**
     * @description Deletes the plan with the given ID.
     *
     * @tags CompanyProviders
     * @name DeleteProviderPlan
     * @summary Deletes the plan with the given ID.
     * @request DELETE:/company-provider/{providerId}/plans/{id}
     * @secure
     */
    deleteProviderPlan: (providerId: number, id: number, params: RequestParams = {}) =>
      this.request<{ data?: boolean }, any>({
        path: `/company-provider/${providerId}/plans/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params
      })
  };
  statuses = {
    /**
     * @description Return list of a status.
     *
     * @tags Statuses
     * @name Statuses
     * @summary Return list of a status
     * @request GET:/statuses
     * @secure
     */
    statuses: (query?: { per_page?: number }, params: RequestParams = {}) =>
      this.request<{ data?: Status[]; links?: PaginatorLinks; meta?: PaginatorMeta }, any>({
        path: `/statuses`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params
      })
  };
  workspaces = {
    /**
     * @description Return workspace models.
     *
     * @tags Workspaces
     * @name Workspaces
     * @summary return Workspace models.
     * @request GET:/workspaces
     * @secure
     */
    workspaces: (params: RequestParams = {}) =>
      this.request<{ data?: any[] }, any>({
        path: `/workspaces`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Retrieves the company design with the given ID.
     *
     * @tags Workspaces
     * @name GetWorkspaceDesign
     * @summary Retrieves the company design with the given ID.
     * @request GET:/workspaces/{app_id}/design
     */
    getWorkspaceDesign: (appId: string, params: RequestParams = {}) =>
      this.request<{ data?: object }, any>({
        path: `/workspaces/${appId}/design`,
        method: 'GET',
        format: 'json',
        ...params
      }),

    /**
     * @description Retrieves the settings of workspace with the given ID.
     *
     * @tags Workspace Settings
     * @name GetCompanySettings
     * @summary Retrieves the settings of workspace with the given ID.
     * @request GET:/workspaces/{id}/settings
     * @secure
     */
    getCompanySettings: (id: number, params: RequestParams = {}) =>
      this.request<{ data?: CompanySettings }, any>({
        path: `/workspaces/${id}/settings`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params
      }),

    /**
     * @description Updates the specified workspace settings by setting the values of the parameters passed.
     *
     * @tags Workspace Settings
     * @name UpdateWorkspaceSettings
     * @summary Updates the specified workspace settings by setting the values of the parameters passed.
     * @request PUT:/workspaces/{id}/settings
     * @secure
     */
    updateWorkspaceSettings: (
      id: number,
      data: {
        primary_color?: string;
        bot_name?: string;
        secondary_color?: string;
        logo?: File;
        tray_icon?: File;
        warning_icon?: File;
        danger_icon?: File;
        success_icon?: File;
        info_icon?: File;
        bot_icon?: File;
        sales_board_id?: number;
        support_board_id?: number;
        override_design?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<{ data?: CompanySettings }, any>({
        path: `/workspaces/${id}/settings`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params
      }),

    /**
     * @description Return a newly settings
     *
     * @tags Workspace Settings
     * @name StoreWorkspaceSettings
     * @summary Store a newly settings.
     * @request POST:/workspaces/{id}/settings
     * @secure
     */
    storeWorkspaceSettings: (
      id: number,
      data: {
        primary_color?: string;
        bot_name?: string;
        secondary_color?: string;
        logo?: File;
        bot_icon?: File;
        tray_icon?: File;
        warning_icon?: File;
        danger_icon?: File;
        success_icon?: File;
        info_icon?: File;
        sales_board_id?: number;
        support_board_id?: number;
        override_design?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<{ data?: CompanySettings }, any>({
        path: `/workspaces/${id}/settings`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: 'json',
        ...params
      }),

    /**
     * @description Deletes the workspace settings with the given ID.
     *
     * @tags Workspace Settings
     * @name DeleteWorkspaceSettings
     * @summary Deletes the company settings with the given ID.
     * @request DELETE:/workspaces/{id}/settings
     * @secure
     */
    deleteWorkspaceSettings: (id: number, params: RequestParams = {}) =>
      this.request<{ data?: boolean }, any>({
        path: `/workspaces/${id}/settings`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params
      })
  };
}
